import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchSO01 = async () => {
  const response = await axios.get(`${WiMuleSQL}/api/BWOS/GetSO01Opm`);

  return response.data.data;
};

export const useSO01 = (enabled = true) =>
  useQuery({
    queryKey: ["SO01"],
    queryFn: () => fetchSO01(),
    enabled,
    staleTime: 60 * 1000, // 1 min if focused
    gcTime: 5 * 60 * 1000, // cache for 5 min if unfocused
    refetchInterval: 60 * 1000, // ← auto-update every minute
  });
